export const getDeviceInformation = () => {
    return {
        /** Device App Version */
        device_app_version: navigator.userAgent,
        /** Device ID */
        device_id: 'device_id', //not available for web broswer
        /** Device Name */
        device_name: 'device_name',
        /** Device OS */
        device_os: navigator.platform || 'device_os',
        /** Device OS Version */
        device_os_version: navigator.appVersion || 'device_os_version', //appVersion is deprecated
        /** Device Type ios | android | web */
        device_type: 'web',
        /** Device Push Token */
        push_token: '',
        /** Device Push User ID */
        user_id: '',
    };
};
